import { GQLValue, GQLValueForTypeKey } from "./isGQLValueOfType";

export type GQLTypeUnionVisitor<TypeUnion extends GQLValue, ReturnValue> = {
    [Type in TypeUnion["__typename"]]: (value: GQLValueForTypeKey<TypeUnion, Type>) => ReturnValue;
} & { unknown: (value: TypeUnion) => ReturnValue };

export function visitGQLUnion<TypeUnion extends GQLValue, ReturnValue>(
    value: TypeUnion,
    visitor: GQLTypeUnionVisitor<TypeUnion, ReturnValue>,
): ReturnValue {
    const type: TypeUnion["__typename"] = value.__typename;
    const visitFunction = visitor[type] ?? visitor.unknown;

    return visitFunction(value as never);
}
